<template>
    <div class="geostatus-map"
         style="        height: 100%;
        width: 100%;
        text-align: center;
        overflow: hidden;
    ">
        <template>
            <fish-modal :width=350 id="review-modal" :visible.sync="showModal">
                <closeIcon id="closeIcon" @click.native="closeModal"></closeIcon>
                <label>{{$t('geoStatusMap.makeReviewHint')}}</label>
                <fish-form>
                    <fish-field id="review-modal-grade">
                        <star-rating v-model="reviewGrade" inactive-color="#000"
                                     active-color="rgb(254, 204, 0)" :show-rating=false :item-size="18"
                                     border-color="ghostwhite" :spacing="20">
                        </star-rating>
                    </fish-field>
                    <fish-field id="review-modal-comment">
                        <fish-input type="textarea" hint="" v-model="reviewComment"></fish-input>
                    </fish-field>
                    <fish-button :loading="isLoading" type="primary" @click="makeReview">{{$t('geoStatusMap.makeReviewSubmit')}}</fish-button>
                </fish-form>
            </fish-modal>
        </template>
        <innerLogo id="geostatus_innerLogo" />
        <fish-field id="key-input">
            <input id="mapInput"
                   v-model="key"
                   placeholder="XXX-XXX"
                   @keyup.enter="submitHandler">
            <inputButton name="mapInputButton" id="mapInputButton" @click.native="submitHandler" />
        </fish-field>
        <a id="geostatus_label_kz" href="https://geostatus.kz" style="        color: #FFFFFF;">kz</a>
        <a id="geostatus_label" href="https://geostatus.kz" style="        color: #A2D9F7;">geostatus.</a>
        <yandex-map :coords="centerCoords"
                    :zoom="zoom"
                    style="height: 100%;
        width: 100%;
        overflow: hidden;"
                    :settings="settings"
                    :scroll-zoom="true"
                    :behaviors="['scrollZoom', 'drag', 'multiTouch']"
                    :controls="['trafficControl', 'geolocationControl']"
                    :placemarks="placemarks"
                    map-type="map"
                    @map-was-initialized="initHandler">

        </yandex-map>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
    import { yandexMap, ymapMarker } from 'vue-yandex-maps'
    import { mapGetters, mapMutations } from 'vuex';
    import axios from 'axios';
    import innerLogo from '../assets/img/innerLogo.vue'
    import inputButton from '../assets/img/inputButton.vue';
    import { StarRating } from 'vue-rate-it';
    import { visit } from '../models';
    import courierIcon from '../assets/img/courierIcon.svg';
    import homeIcon from '../assets/img/homeIcon.svg';
    import homeFinishIcon from "../assets/img/homeIcon_finish.svg";
    import closeIcon from "../assets/img/closeIcon.vue";
    import loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "visitMap",
        data() {
            return {
                timer: '',
                map: {},
                model: new visit(),
                placemarks: [],
                settings: {
                    lang: this.$i18n.locale == "en" ? 'en_US' : this.$i18n.locale == "tr" ? "tr_TR" : "ru_RU"
                },
                key: '',
                zoom: 13,
                centerCoords: [48, 67],
                init: false,
                isLoading: true,
                reviewGrade: undefined,
                reviewComment: undefined,
                reviewDone: false,
                showModal: false
            }
        },
        components: { yandexMap, ymapMarker, innerLogo, inputButton, loading, StarRating, closeIcon },
        methods: {
            ...mapMutations(['editVisit']),
            initHandler(map) {
                if (!this.visit.key) {
                    this.messageErrorHandler(this.$t('geoStatusMap.wrongKeyErrorHandlerMessage'));
                    this.$router.replace({ name: "home" });
                };
                this.map = map;
                this.fetchVisit();
                this.timer = setInterval(this.fetchVisit, 30000)

            },
            getReview() {
                this.isLoading = true;
                axios({
                    method: 'post',
                    url: '/Operations/GetReview?key=' + this.model.key
                })
                    .then(response => {
                        this.reviewDone = true;
                        this.isLoading = false;
                        this.messageSuccessHandler(this.$t('geoStatusMap.reviewErrorHandlerMessage'))
                    }).catch(error => {
                        this.reviewDone = false;
                        this.showModal = true;
                        this.isLoading = false;
                    })

            },
            messageErrorHandler(message) {
                this.$message.error(message, 3000)
            },
            messageSuccessHandler(message) {
                this.$message.success(message, 3000)
            },
            fetchVisit() {
                axios.post('/Operations/Process?key=' + this.model.key
                ).then(response => {

                    if (!this.timer) {
                        this.timer = setInterval(this.fetchVisit, 10000)
                    }

                    const visit = response.data.results.visit;
                    const user = response.data.results.user;

                    this.model.visitStatus = visit.status;
                    this.model.title = visit.title;
                    this.model.objectLatitude = visit.location.latitude;
                    this.model.objectLongitude = visit.location.longitude;

                    if (user != null & (this.model.visitStatus == "Pending" || this.model.visitStatus == "Execution")) {

                        this.model.userLatitude = user.location.latitude;
                        this.model.userLongitude = user.location.longitude;

                        this.placemarks = [
                            {
                                coords: [this.model.objectLatitude, this.model.objectLongitude],
                                properties: {
                                    balloonContent: this.$t('geoStatusMap.objectBalloonContentTitle'),
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: homeIcon,
                                    iconImageSize: [50, 88],
                                    iconImageOffset: [-15, -75],
                                },
                                markerId: 1
                            },
                            {
                                coords: [this.model.userLatitude, this.model.userLongitude],
                                properties: {
                                    balloonContent: this.$t('geoStatusMap.workerBalloonContentTitle'),
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: courierIcon,
                                    iconImageSize: [50, 88],
                                    iconImageOffset: [-15, -75],
                                },
                                markerId: 2
                            }];

                        this.editVisit(this.model);
                        setTimeout(() => {
                            this.map.setCenter(this.findMiddleCoords(this.model));
                            this.map.setZoom(this.calculateZoom(this.model));
                            this.isLoading = false;
                        }, 300);

                    }
                    else {
                        this.centerCoords = [this.model.objectLatitude, this.model.objectLongitude];

                        this.placemarks = [
                            {
                                coords: [this.model.objectLatitude, this.model.objectLongitude],
                                properties: {
                                    balloonContent: this.$t('geoStatusMap.objectBalloonContentTitle'),
                                },
                                options: {
                                    iconLayout: 'default#image',
                                    iconImageHref: this.model.visitStatus == "Completed" ? homeFinishIcon : homeIcon,
                                    iconImageSize: [50, 88],
                                    iconImageOffset: [-15, -75],
                                },
                                markerId: 1
                            }];

                        if (this.model.visitStatus == "Completed") {
                            this.cancelAutoUpdate();
                            this.getReview();
                        }

                        this.map.setZoom(13);
                        this.isLoading = false;
                    }
                })
                    .catch(e => {
                        this.cancelAutoUpdate();
                        this.isLoading = false;
                        this.messageErrorHandler(this.$t('geoStatusMap.wrongKeyErrorHandlerMessage'));
                        this.$router.replace({ name: "home" });
                    });
            },
            submitHandler() {
                this.isLoading = true;

                if (this.model.key != this.key)
                    this.model.key = this.key;

                this.fetchVisit();
            },
            findMiddleCoords(model) {
                const center = [((model.objectLatitude + model.userLatitude) / 2), ((model.userLongitude + model.objectLongitude) / 2)];
                return center;
            },
            cancelAutoUpdate() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = false;
                }
            },
            calculateDistance(lat1, lon1, lat2, lon2) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                }
                else {
                    var radlat1 = Math.PI * lat1 / 180;
                    var radlat2 = Math.PI * lat2 / 180;
                    var theta = lon1 - lon2;
                    var radtheta = Math.PI * theta / 180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180 / Math.PI;
                    dist = dist * 60 * 1.1515;
                    dist = dist * 1.609344;
                    return dist;
                }
            },
            calculateZoom(model) {
                const distance = this.calculateDistance(model.objectLatitude, model.objectLongitude, model.userLatitude, model.userLongitude);
                if (distance <= 0.2)
                    return 18;
                else if (distance <= 0.5)
                    return 17;
                else if (distance <= 1)
                    return 16;
                else if (distance <= 5)
                    return 14;
                else if (distance <= 10)
                    return 13;
                else if (distance <= 20)
                    return 12;
                else if (distance <= 40)
                    return 11;
                else if (distance <= 70)
                    return 10;
                else if (distance <= 150)
                    return 9;
                else if (distance <= 300)
                    return 8;
                else if (distance <= 600)
                    return 7;
                else if (distance <= 1200)
                    return 6;
                else return 5;
            },
            makeReview() {
                this.isLoading = true;
                axios({
                    method: 'post',
                    url: '/Operations/MakeReview?key=' + this.model.key,
                    data: {
                        grade: this.reviewGrade,
                        comment: this.reviewComment
                    }
                })
                    .then(response => {
                        this.reviewDone = true;
                        this.showModal = false;
                        this.messageSuccessHandler(this.$t('geoStatusMap.reviewSuccessHandlerMessage'))
                        this.isLoading = false;
                    }).catch(error => {
                        this.messageErrorHandler(this.$t('geoStatusMap.errorHandlerMessage'));
                    });
            },
            closeModal() {
                this.showModal = false;
            }
        },
        beforeDestroy() {
            clearInterval(this.timer)
            this.timer = false;
        },
        created: function () {
            if (this.$route.query.key != null)
                this.visit.key = this.$route.query.key;
            if (!this.visit.key) {
                this.messageErrorHandler(this.$t('geoStatusMap.wrongKeyErrorHandlerMessage'));
                this.$router.replace({ name: "home" });
            }
            this.model = this.visit;
            this.key = this.model.key;


        },
        computed: {
            ...mapGetters(['visit'])
        }
    }

</script>

<style lang="stylus">

    #closeIcon {
        width: 20px;
        position: absolute;
        right: 15px;
        top: 10px;
        cursor: pointer;
    }

    .fish.dimmer {
        background-color: rgba(0,0,0, 0.7) !important;
    }

    div.vue-rate-it-rating div.vue-rate-it-pointer.vue-rate-it-rating-item {
        padding: 4px;
    }

    div.fish.modal {
        margin-top: 17% !important;
    }

        div.fish.modal div.content label {
            margin-top: 40px;
            display: block;
            color: ghostwhite;
            font-size: 21px;
            margin-bottom: 10px;
        }

        div.fish.modal div.content form.fish.form div#review-modal-grade.field {
            padding: 10px;
            text-align: center;
        }

            div.fish.modal div.content form.fish.form div#review-modal-grade.field div {
                display: inline-block;
            }

        div.fish.modal div.content form.fish.form div.fish.button.primary {
            margin-top: 80px;
            right: auto;
            display: inline-block;
            text-align: center;
            position: relative;
            width: 180px;
            background-color: #000;
            border: 2px solid lightblue;
            border-radius: 26px;
            color: lightblue;
            margin-bottom: 20px;
            font-size: large;
            padding: 6px;
            font-weight: lighter;
            font-family: 'GothamPro';
        }

        div.fish.modal div.content form.fish.form div#review-modal-comment.field div {
            background-color: #000;
        }

            div.fish.modal div.content form.fish.form div#review-modal-comment.field div div.fish.input textarea {
                background: #000000;
                color: white;
                border: 2px solid #fff;
                border-radius: 15px;
                resize: none;
                font-size: 12px;
                overflow: hidden;
                height: 100px;
                min-width: 200px;
            }

        div.fish.modal div.content {
            text-align: center;
            padding: 2em;
            background-color: #000;
            color: #FFF;
        }

    #mapInput {
        border-radius: 25px !important;
        border: 1px solid #283f61 !important;
        width: 300px !important;
        background: #007cc2;
        color: #FFFFFF !important;
        height: 37px;
        margin-right: 13px;
        padding-left: 10px;
        text-transform: uppercase;
    }

        #mapInput::placeholder {
            color: #FFFFFF !important;
        }

    #key-input {
        display: inline-block;
        line-height: 100px;
        padding-right: 20px;
    }

    #mapInputButton {
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        height: 30px;
        width: 30px;
        vertical-align: middle;
        margin-bottom: 4px;
        cursor: pointer;
    }

    #geostatus_innerLogo {
        height: 100px;
        width: 160px;
        display: inline-block;
        margin-top: auto;
        margin-bottom: auto;
        padding-left: 20px;
        float: left;
    }

    #geostatus_label {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        margin-bottom: auto;
        box-sizing: content-box;
        float: right;
        font-size: large;
        line-height: 100px;
    }

    #geostatus_label_kz {
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        margin-bottom: auto;
        box-sizing: content-box;
        float: right;
        font-size: large;
        line-height: 100px;
        padding-right: 20px;
    }

    .ymap-body {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 768px) {

        html body geostatus-widget div#geostatus_widget div.geostatus-map div.field {
            display: inline-block;
        }

        #mapInput {
            border-radius: 25px !important;
            border: 1px solid #283f61 !important;
            width: 250px !important;
            background: #007cc2;
            color: #FFFFFF !important;
            height: 37px;
            text-transform: uppercase;
        }

        #geostatus_innerLogo {
            display: none;
        }

        #geostatus_label {
            display: none;
        }

        #geostatus_label_kz {
            display: none;
        }
    }
</style>


